import type { ApiResponse, ParamPaymentInitResponse } from '../types';

/** Param dönüş URL'lerinde nadiren &amp; kalabiliyor; tarayıcı 3D'ye gitmez veya hata verir. */
export function normalizePaymentRedirectUrl(url: string): string {
  return String(url).trim().replace(/&amp;/g, '&');
}

/**
 * create/renew yanıtından 3D adresini alır (camelCase / PascalCase / üst seviye yedek).
 * API: SubscriptionDTOs.ParamPaymentInitResponse.PaymentUrl — JSON varsayılan camelCase: paymentUrl.
 */
export function getParamPaymentUrl(response: ApiResponse<ParamPaymentInitResponse>): string | undefined {
  const root = response as unknown as Record<string, unknown>;
  const bag = (response?.data as unknown as Record<string, unknown> | null | undefined) ?? undefined;

  const pick = (...vals: unknown[]): string | undefined => {
    for (const v of vals) {
      if (typeof v === 'string' && v.trim().length > 0) return v.trim();
    }
    return undefined;
  };

  const raw = pick(
    bag?.paymentUrl,
    bag?.PaymentUrl,
    bag && (bag as { paymentURL?: string }).paymentURL,
    root?.paymentUrl,
    root?.PaymentUrl
  );

  return raw ? normalizePaymentRedirectUrl(raw) : undefined;
}

/** 3D sayfasına tam sayfa geçiş (geri tuşu yığınını azaltır). */
export function redirectToParam3d(paymentUrl: string): void {
  const u = normalizePaymentRedirectUrl(paymentUrl);
  if (!/^https?:\/\//i.test(u)) {
    // eslint-disable-next-line no-console
    console.error('Param 3D URL geçersiz (http/https beklenir):', u);
    return;
  }
  window.location.replace(u);
}
